import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import { jqTextCopy, scrollGallery } from 'javascripts/general_scripts';

jqTextCopy();
scrollGallery();